export const FEE_RATE_PRECISION = 5;
const roundStringValue = (value, precision = 2) => {
    return Number(value).toFixed(precision);
};
export default roundStringValue;
